const baseUrl = "/rastreio"

// GET
export const GET_FILTER_RASTREIO = baseUrl + "/"
export const GET_OPTIONS = baseUrl + "/options"
export const GET_GESTAO = baseUrl + "/gestao"
export const GET_REPORT_CHECKBOXES = baseUrl + "/report/checkboxes"

// POST
export const POST_FILTER_RASTREIO = baseUrl + "/"
export const POST_REPORT_FILE = baseUrl + "/reportFile"
export const POST_REPORT = baseUrl + "/report"
export const POST_REPORT_HISTORY = baseUrl + "/report/history"
